document.addEventListener('DOMContentLoaded', () => {
  /*
    ============================================================
    ASK Smooth Scroll Modes
    ------------------------------------------------------------
    Change this ONE value anytime you want to switch modes:

      'premium'   = polished, quick, premium default
      'cinematic' = slower, more dramatic, luxury feel
      'adaptive'  = premium for short jumps, cinematic for long jumps

    Recommended launch default for ASK:
      const ASK_SCROLL_MODE = 'adaptive';
    ============================================================
  */
  const ASK_SCROLL_MODE = 'adaptive';

  const anchorLinks = document.querySelectorAll('a[href^="#"]');

  /*
    ------------------------------------------------------------
    Header offset
    ------------------------------------------------------------
    Uses your actual theme header structure first, then falls back.
  */
  const getHeaderOffset = () => {
    const header =
      document.querySelector('header-component') ||
      document.querySelector('.shopify-section-header-sticky') ||
      document.querySelector('.section-header') ||
      document.querySelector('header');

    if (!header) return window.innerWidth <= 749 ? 84 : 110;

    const headerHeight = header.getBoundingClientRect().height || 0;
    return headerHeight + (window.innerWidth <= 749 ? 12 : 16);
  };

  /*
    ------------------------------------------------------------
    Easing functions
    ------------------------------------------------------------
  */
  const easeInOutCubic = (t) => {
    return t < 0.5
      ? 4 * t * t * t
      : 1 - Math.pow(-2 * t + 2, 3) / 2;
  };

  const easeInOutQuint = (t) => {
    return t < 0.5
      ? 16 * t * t * t * t * t
      : 1 - Math.pow(-2 * t + 2, 5) / 2;
  };

  /*
    ------------------------------------------------------------
    Scroll mode config
    ------------------------------------------------------------
  */
  const getPremiumConfig = (absDistance) => {
    let duration = 900;

    if (absDistance < 500) duration = 650;
    else if (absDistance < 1200) duration = 850;
    else if (absDistance < 2200) duration = 1000;
    else duration = 1150;

    return {
      duration,
      easing: easeInOutCubic
    };
  };

  const getCinematicConfig = (absDistance) => {
    let duration = 1100;

    if (absDistance < 500) duration = 800;
    else if (absDistance < 1200) duration = 1050;
    else if (absDistance < 2200) duration = 1350;
    else duration = 1600;

    return {
      duration,
      easing: easeInOutQuint
    };
  };

  const getAdaptiveConfig = (absDistance) => {
    /*
      Adaptive logic:
      - short jumps behave like premium
      - medium jumps blend the feel
      - long jumps behave like cinematic
    */
    if (absDistance < 650) {
      return getPremiumConfig(absDistance);
    }

    if (absDistance < 1600) {
      return {
        duration: 1000,
        easing: easeInOutCubic
      };
    }

    return getCinematicConfig(absDistance);
  };

  const getScrollConfig = (distance) => {
    const absDistance = Math.abs(distance);

    if (ASK_SCROLL_MODE === 'cinematic') {
      return getCinematicConfig(absDistance);
    }

    if (ASK_SCROLL_MODE === 'adaptive') {
      return getAdaptiveConfig(absDistance);
    }

    return getPremiumConfig(absDistance);
  };

  /*
    ------------------------------------------------------------
    Smooth scroll animation
    ------------------------------------------------------------
  */
  const smoothScrollTo = (targetY) => {
    const startY = window.pageYOffset;
    const distance = targetY - startY;

    if (Math.abs(distance) < 4) return;

    const { duration, easing } = getScrollConfig(distance);
    const startTime = performance.now();

    const step = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = easing(progress);

      window.scrollTo(0, startY + distance * eased);

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  };

  /*
    ------------------------------------------------------------
    Anchor click handling
    ------------------------------------------------------------
    Handles:
    - hero buttons
    - header links
    - footer links
    - any in-page #ask-* anchor
  */
  anchorLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      const href = link.getAttribute('href');

      if (!href || href === '#' || href.length < 2) return;
      if (!href.startsWith('#')) return;

      const target = document.querySelector(href);
      if (!target) return;

      event.preventDefault();

      const headerOffset = getHeaderOffset();
      const targetTop =
        target.getBoundingClientRect().top + window.pageYOffset - headerOffset;

      smoothScrollTo(targetTop);

      if (history.pushState) {
        history.pushState(null, '', href);
      } else {
        window.location.hash = href;
      }
    });
  });

  /*
    ------------------------------------------------------------
    If page loads with a hash, land correctly below sticky header
    ------------------------------------------------------------
  */
  if (window.location.hash) {
    const target = document.querySelector(window.location.hash);

    if (target) {
      setTimeout(() => {
        const headerOffset = getHeaderOffset();
        const targetTop =
          target.getBoundingClientRect().top + window.pageYOffset - headerOffset;

        window.scrollTo(0, targetTop);
      }, 50);
    }
  }
});